import { render, staticRenderFns } from "./ColumnBox.vue?vue&type=template&id=c3a9ac48"
import script from "./ColumnBox.vue?vue&type=script&lang=js"
export * from "./ColumnBox.vue?vue&type=script&lang=js"
import style0 from "./ColumnBox.vue?vue&type=style&index=0&id=c3a9ac48&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports